import { render, staticRenderFns } from "./ArticuloPage.vue?vue&type=template&id=1709a61c&scoped=true&lang=pug&"
import script from "./ArticuloPage.ts?vue&type=script&lang=ts&"
export * from "./ArticuloPage.ts?vue&type=script&lang=ts&"
import style0 from "./ArticuloPage.vue?vue&type=style&index=0&id=1709a61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1709a61c",
  null
  
)

export default component.exports